<div class="code-input">
  <div class="code-input__message" *ngIf="title.length > 0">{{title}}</div>

  <div class="code-input__input-wrapper">
    <input type="text"
           #inputEl
           [disabled]="disabledInputs[idx]"
           (keydown)="beforeInputChange($event, idx)"
           (keyup)="afterInputChange($event, idx)"
           (paste)="onPaste($event, idx)"
           enterkeyhint="go"
           (submit)="submit()"
           *ngFor="let input of [].constructor(codeLength); index as idx">
  </div>

  <div class="code-input__confirm" (click)="submit()">
    <brt-button [title]="submitButtonLabel" [color]="'river'" [disabled]="!isConfirmEnabled || isLoading"></brt-button>
  </div>
</div>
